<template>
  <div class="privacy">
    <div class="privacy-wrapper moreDd">
      <div class="privacy-title">各位尊敬的陌多多用户:</div>
      <div class="privacy-content">
        由于陌多多运营公司海南喵咖网络科技有限公司（“我司”）的运营策略调整，陌多多将于2022年【2】月【15】日【12】时停止运营，届时将无法提供现有的各项服务。自陌多多上线以来，得到了广大用户的大力支持与厚爱，陌多多全体工作人员由衷感激各位用户给予的支持与帮助，在此也对由于本次运营策略调整给大家造成的不便，表示深深的遗憾与歉意！
      </div>
      <div class="privacy-content">
        同时，为了保障各位陌多多用户（“您”）的权益和体验，我们提供了如下两种方案供您选择：
      </div>
      <div class="privacy-content">
        （一）我们可将您的帐号及帐号内相关数据信息(“帐号数据”)转移至我司关联公司运营的另外一款社交产品“{{appName}}”，具体转移方案和转移流程如下：
      </div>
      <div class="privacy-content">
        <b>1. 转移步骤：</b>
      </div>
      <div class="privacy-content">
        （1） 您需完整阅读本停运转移通知； <br />
        （2）
        您需授权{{appName}}收集您已向陌多多提供的必要个人信息（具体见本条第3款），以实现帐号数据的顺利转移；<br />
        （3） 您点击“同意转移”，视为您已充分理解本通知内容并授权{{appName}}收集您的必要个人信息； <br />
        （4）
        您同意转移后，陌多多会帮您自动下载{{appName}}并安装，安装成功后，您可使用陌多多的注册绑定手机号登录{{appName}}；<br />
        （5）
        您点击同意《{{appName}}用户协议》及《{{appName}}隐私政策》登录{{appName}}后，{{appName}}将基于陌多多账号数据为您提供服务
      </div>
      <div class="privacy-content">
        <b>2. 帐号数据转移规则<br />陌多多内账号数据包括用户个人信息、陌多多金币、钱包金额等。</b>
      </div>
      <div class="privacy-content">
        （1）
        用户个人信息：您的个人信息，包括注册绑定手机号码，昵称，头像，性别、生日、身高，体重等将自动嵌入{{appName}}的用户个人信息。{{appName}}只支持中文昵称，如您的陌多多昵称含英文字母，则{{appName}}系统会随机生成昵称，您可在个人信息中进行修改。
        <br />（2）
        陌多多金币：您的陌多多金币将根据{{appName}}爱心和人民币的兑换比例进行等值兑换，如100陌多多金币将转移为【16】爱心。
        <br />（3）
        钱包余额：建议您在陌多多内完成钱包内余额的提现，如您未提现，则转移至{{appName}}后将会产生8%的折损，如100元人民币余额转移至{{appName}}后，自动转为92元人民币余额。
      </div>
      <div class="privacy-content">
        <b>3. 个人信息转移授权</b>
      </div>
      <div class="privacy-content">
        为实现帐号数据的顺利转移，在您同意转移后，{{appName}}的运营公司成都陌陌科技有限公司（“{{appName}}”）需要向您收集您已向陌多多提供或产生的如下个人信息，请您仔细阅读并理解：
        <br />（1） {{appName}}会收集您在陌多多注册绑定的手机号码、昵称、性别、生日，用于为您创建{{appName}}帐号。
        <br />（2） {{appName}}会收集您在陌多多上传的头像照片，用于为您创建{{appName}}的帐号头像。 <br />（3）
        {{appName}}会收集您在陌多多内填写的身高、体重用于创建{{appName}}帐号后的个人资料的转移。 <br />（4）
        {{appName}}会收集您在陌多多内剩余的虚拟币信息，用于等值兑换为{{appName}}的虚拟货币。 <br />（5）
        {{appName}}会收集您在陌多多内剩余的钱包余额信息，用于转移至{{appName}}的钱包余额。<br />
        {{appName}}将按照<b>《{{appName}}隐私政策》</b>来保护向您收集的上述个人信息。
      </div>
      <div class="privacy-content">
        （二）
        如您不同意迁移，则请您在【2022】年【2】月【15】日之前将陌多多内的余额提现并联系陌多多客服进行剩余虚拟货币的退款事宜，同时提醒您注意对您在陌多多上的内容进行备份，避免相关内容在陌多多停止运营后无法找回。
      </div>
      <div class="privacy-content">
        如您逾期未申请，视为您自动放弃转移/退费的权利，陌多多将不再处理。
      </div>
      <div class="privacy-date">陌多多运营公司：海南喵咖网络科技有限公司</div>
      <div class="privacy-date privacy-date-second">
        {{appName}}运营公司：成都陌陌科技有限公司
      </div>
      <div class="privacy-date privacy-date-second">
        2022年【2】月【10】日
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tab1 {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  tr {
    font-size: 16px;
  }
  .tr1 {
    width: 100px;
  }
  .tr2 {
    min-width: 40px;
  }
  .tr3 {
    width: 80px;
  }
  .tr4 {
    width: 100px;
  }
  .tr5 {
    max-width: 350px;
    word-break: break-all;
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
}
.privacy-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
  &.moreDd {
    padding-top: 40px;
  }
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
  .phone {
    text-decoration: underline;
  }
}
.moreDd {
  .privacy-date {
    width: 100%;
    margin-left: 0;
    text-align: right;
    font-weight: bolder;
  }
}
</style>
<script>
const { mm } = window;
export default {
  name: "Privacy",
  data() {
    return {
      IOSUser: false,
      appName: this.$store.state.appName,
    };
  },
  mounted() {},
  components: {},
  created() {
    const iOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (iOS) {
      this.IOSUser = iOS;
      // console.log("iOS终端", iOS);
    }
    document.title = "陌多多转移通知";
  },
  methods: {
    callServe(phone) {
      mm.ui.openUrl({
        target: 3,
        url: ` goto://MultiFunction_Action_Protocol?action=dail&content=${phone}`
      });
    }
  }
};
</script>
